import {NgModule} from "@angular/core";
import {CustomItemAccordionComponent} from "./custom-item-accordion.component";
import {CustomIconsModule} from "../../../../icons/custom-icons.module";
import {CommonModule} from "@angular/common";
import {CmsConfig, ConfigModule, I18nModule} from "@spartacus/core";

@NgModule({
  declarations: [CustomItemAccordionComponent],
  exports: [CustomItemAccordionComponent],
  imports: [
    CommonModule,
    I18nModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccordionItemComponent: {
          component: CustomItemAccordionComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomItemAccordionModule {}
